function ShieldIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 35 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.649 43.82l2.102.902c.18.06.42.12.6.12.181 0 .421-.06.602-.12l2.402-1.022c8.71-3.604 14.297-12.014 14.297-21.445V10.602c0-.541-.3-1.082-.78-1.322L18.131.87 1.434 9.28c-.48.24-.78.78-.78 1.322v11.894c0 9.25 5.466 17.6 13.996 21.325zm-3.424-23.547l4.145 4.866 9.61-7.81 1.923 2.343-10.692 8.77-1.142.962-.96-1.142-5.107-6.007 2.223-1.982z"
        fill="#AEAAB5"
      />
    </svg>
  )
}

export default ShieldIcon
